import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Platform } from 'react-native';

import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../utils/env';

import { ExpoStorageAdapter } from './storageAdapter';


let supabaseClient: SupabaseClient<any> | null = null;

function initSupabaseClient(): SupabaseClient<any> {
  if (supabaseClient) return supabaseClient;

  const url = SUPABASE_URL;
  const key = SUPABASE_ANON_KEY;

  if (!url || !key) {
    throw new Error(
      `Supabase client cannot be initialized: missing URL or key. URL=${url ? 'set' : 'missing'}, KEY=${key ? 'set' : 'missing'}`
    );
  }

  if (__DEV__) {
    console.log('SUPABASE_URL:', url);
    console.log('SUPABASE_ANON_KEY:', key.substring(0, 8) + '...');
    console.log('Initializing Supabase client with URL:', url.substring(0, 30) + '...');
  }

  supabaseClient = createClient<any>(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: Platform.OS === 'web',
      storage: Platform.OS === 'web' ? window.localStorage : (ExpoStorageAdapter as any),
      storageKey: 'supabase.auth.token',
      flowType: 'pkce',
    },
    global: {
      headers: {
        'X-Client-Info': 'bible-quiz-app/1.0.0',
      },
    },
    realtime: {
      params: {
        eventsPerSecond: 5,
      },
    },
  });

  if (__DEV__) {
    console.log('Supabase client initialized successfully');
  }

  return supabaseClient;
}

// Lazy-init: client is created on first access, not at module load time.
// This prevents crashes when the JS runtime isn't fully ready (e.g. during
// expo-updates bootstrap or when env vars haven't been injected yet).
export const supabase: SupabaseClient<any> = new Proxy({} as SupabaseClient<any>, {
  get(_target, prop) {
    const client = initSupabaseClient();
    return (client as any)[prop];
  },
});
export default supabase;
